import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const updatePrompt = (promptId, payload, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'UPDATING_PROMPT' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.put(`/ads/prompt/${promptId}`, payload, {
            params: {
              'request-id': reqId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'UPDATING_PROMPT_DONE',
              payload: {
                promptId: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(promptId);
            }
          } else {
            dispatch({
              type: 'UPDATING_PROMPT_FAILED',
              payload: `Failed to update prompt`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'UPDATING_PROMPT_FAILED',
            payload: `Failed to update prompt`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'UPDATING_PROMPT_FAILED',
        payload: `Failed to update prompt`,
      });
    }
  };
};

export default updatePrompt;
